import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { LEAD, fmtDateTime } from "@/lib/format";
import { Pill } from "@/components/Common";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";

export function LeadDialog({ p, onOpenChange, onDone }) {
  const [notes, setNotes] = useState("");
  const [hist, setHist] = useState([]);
  useEffect(() => {
    if (p) {
      setNotes("");
      api.get(`/admin/participants/${p.id}/lead-history`).then((r) => setHist(r.data.items));
    }
  }, [p]);
  const set = async (status) => {
    try {
      await api.post(`/admin/participants/${p.id}/lead`, { status, notes });
      toast.success(`Status Lead: ${LEAD[status].label}`);
      onDone();
      onOpenChange(false);
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  return (
    <Dialog open={!!p} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md" data-testid="lead-dialog">
        <DialogHeader>
          <DialogTitle>Eligibilitas Lead · {p?.full_name}</DialogTitle>
          <DialogDescription>Status saat ini: {LEAD[p?.lead_status]?.label}</DialogDescription>
        </DialogHeader>
        <Textarea placeholder="Catatan (opsional)" value={notes} onChange={(e) => setNotes(e.target.value)} data-testid="lead-notes-input" />
        <div className="grid grid-cols-2 gap-2">
          <Button className="bg-green-700 hover:bg-green-800" onClick={() => set("VERIFIED")} data-testid="lead-verify-button">Verifikasi</Button>
          <Button variant="outline" className="border-red-300 text-red-700" onClick={() => set("REVOKED")} disabled={p?.lead_status !== "VERIFIED"} data-testid="lead-revoke-button">Cabut</Button>
        </div>
        {hist.length > 0 && (
          <div className="max-h-40 space-y-1 overflow-y-auto text-xs">
            {hist.map((h) => <div key={h.id} className="rounded bg-[#F5F3EB] p-2"><b>{h.status}</b> oleh {h.verified_by_name} · {fmtDateTime(h.created_at)}{h.notes ? ` — ${h.notes}` : ""}</div>)}
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}

export const LeadPill = ({ s }) => <Pill className={(LEAD[s] || LEAD.NOT_VERIFIED).cls}>{(LEAD[s] || LEAD.NOT_VERIFIED).label}</Pill>;
